<template>
  <div id="push-list">
    <Info :info="info"/>
    <TableDef :rows="messages">
      <template slot="slot_head">
        <th :style="{width: '170px'}">推播類型</th>
        <th :style="{textAlign: 'start', width: 'inherit'}">內容</th>
        <th :style="{width: '180px'}">受眾對象/條件</th>
        <th :style="{width: '170px'}">傳送受眾人數</th>
        <th :style="{textAlign: 'start', width: '210px'}">儲存時間</th>
        <th :style="{textAlign: 'center', width: '90px'}">編輯</th>
        <th :style="{textAlign: 'center', width: '90px'}">刪除</th>
      </template>
      <tr slot-scope="{item, index}" class="record" :style="{minHeight: '100px', borderBottom: '1px solid #B9B9B9'}">
        <td><div class="type" :style="{
          backgroundColor: (item.messageType === 'coupon' || item.messageType === 'couponWithText')
          ? '#FFB55F' :
          toDateTime(item.sendTime) !== toDateTime(item.createTime) ? '#CCA16E'
          : 'var(--color-checked)'
          }">
          {{
          (item.messageType === 'coupon' || item.messageType === 'couponWithText')
          ? '票券發送' :
          (toDateTime(item.sendTime) !== toDateTime(item.createTime) && /coupon/.test(item.messageType)) ? '預約票券' :
          (toDateTime(item.sendTime) !== toDateTime(item.createTime) && !/coupon/.test(item.messageType)) ? '預約活動'
          : '活動公告'}}
        </div></td>
          <td :style="{paddingBlock: '14px', textAlign: 'start'}">
            <div v-if="item.coupons">
              <CouponBox v-if="item.coupons&&item.coupons[0]&&item.coupons[0].coupon"
              :style="{width: '100%', maxWidth: '650px', boxSizing: 'border-box', borderRadius:'5px'}"
              :image="item.coupons[0].coupon.image||''"
              :couponName="item.coupons[0].coupon.couponName"
              :productName="item.coupons[0].coupon.productName"
              :productID="item.coupons[0].coupon.productID"
              :startTime="item.coupons[0].coupon.startTime"
              :expireTime="item.coupons[0].coupon.expireTime"
              :duration="item.coupons[0].coupon.duration"
              :icon="'none'"
              />
              <div>
                優惠券 {{item.coupons.length}}項
                共計 {{reduce(item.coupons.map(e => e.count))}}張
              </div>
            </div>
            <CouponBox v-if="item.coupon" :style="{width: '100%', boxSizing: 'border-box'}"
            :image="item.coupon.image||''"
            :couponName="item.coupon.couponName"
            :productName="item.coupon.productName"
            :productID="item.coupon.productID"
            :startTime="item.coupon.startTime"
            :expireTime="item.coupon.expireTime"
            :duration="item.coupon.duration"
            :icon="'none'"
            />
            <div class="message" v-if="item.messageType==='text'||item.type==='couponWithText'" :style="{}">{{item.textContent}}</div>
            <div class="message" v-if="item.messageType==='image'" :style="{minHeight: '300px'}">
              <img :src="`${VUE_APP_BASE_URL}/message/${item.imageUrl}`" :style="{maxHeight:'272px'}"></div>
            <div class="bubble" v-if="item.messageType==='bubble'">
              <div :style="{maxHeight: '180px'}"><img :src="`${VUE_APP_BASE_URL}/${item.bubbleImage}`" :style="{maxHeight: '180px'}"></div>
              <div>
                <div>{{item.bubbleHeader}}</div>
                <a :href="item.bubbleLink" v-if="item.bubbleLink" :title="item.bubbleLink">{{item.bubbleLink.split('/').slice(0, 4).join('/')}}{{item.bubbleLink.split('/').length>4?'...':''}}</a>
                <div class="bubble-content">{{item.bubbleContent}}</div>
              </div>
            </div>
          </td>
          <td class="poptd" :style="{paddingBlock: '21px'}">
            <div class="ff">
              <span>查看受眾</span>
              <div class="pop" v-if="getpopava(item.targetFilters)">
              <div v-if="item.targetFilters.role&&item.targetFilters.role.length>0">
                <div>角色</div>
                <div>{{item.targetFilters.role.map(e => roles[e]).join('/')}}</div>
              </div>
              <div v-if="item.targetFilters.gender&&item.targetFilters.gender.length>0">
                <div>性別</div>
                <div>{{item.targetFilters.gender.join('/')}}</div>
              </div>
              <div v-if="item.targetFilters.age&&item.targetFilters.age.legnth>0">
                <div>年齡</div>
                <div>{{item.targetFilters.age.join('/')}}</div>
              </div>
              <div v-if="item.targetFilters.country&&item.targetFilters.country.length>0">
                <div>地區</div>
                <div>{{item.targetFilters.country.join('/')}}</div>
              </div>
              <div v-if="item.targetFilters.consumeNumber">
                <div>條件</div>
                <div></div>
                <div>{{item.targetFilters.consume}} {{item.targetFilters.consumeNumber}} 元</div>
              </div>
            </div></div>
            <div :style="{marginTop: '3px'}">{{item.targetFilters?.consume}}</div>
          </td>
          <td>{{item.targets.length}}</td>
          <td :style="{textAlign: 'start'}" v-html="moment(item.sendTime).format('yyyy/MM/DD<br>HH:mm')"></td>
          <td :style="{textAlign: 'center'}"><EditBtn @click="$router.push({ name: $route.name, query: { page: item.targetFilters?.consume === '指定' ? '指定推播' : '新增推播', id: item._id } })" :style="{margin: 'auto'}"/></td>
          <td :style="{textAlign: 'center'}"><DelBtn @click="removeOne(item, index)" :style="{margin: 'auto', transform: 'scale(1.2)'}"/></td>
      </tr>
    </TableDef>
  </div>
</template>

<script>
import DelBtn from '../../components/btn/del.vue'
import EditBtn from '../../components/btn/edit.vue'
import CouponBox from '../../components/couponBox.vue'
import Info from './message/lineinfobox.vue'
import { getapi, deleteapi } from '../../store/fetch'
import TableDef from '../../components/tables/t2.vue'
const { VUE_APP_BASE_URL } = process.env
export default {
  props: ['info', 'page'],
  components: {
    Info,
    CouponBox,
    DelBtn,
    EditBtn,
    TableDef
  },
  data () {
    return {
      VUE_APP_BASE_URL,
      messages: [],
      count: 0,
      types: {
        couponWithText: ''
      },
      roles: {
        agency: '代理商窗口',
        leader: '領隊導遊',
        user: '會員'
      }
    }
  },
  watch: {
    async page () { await this.getmessage() }
  },
  async mounted () {
    await this.getmessage()
  },
  methods: {
    async removeOne (item, index) {
      const r = await deleteapi(`message/${item._id}`)
      if (r) {
        console.log('index', index)
        this.messages.splice(index, 1)
      }
    },
    getpopava (ev) {
      if (!ev) {
        return false
      }
      if (Object.keys(ev).length === 1 && Object.keys(ev)[0] === 'consume') {
        return false
      }
      console.log('ev', Object.keys(ev), Object.keys(ev).length, ev[Object.keys(ev)[0]])
      return true
    },
    async getmessage () {
      const params = {
        page: this.page
      }
      const messages = await getapi('message/temp?' + new URLSearchParams(params))
      this.messages = messages.data
      this.count = messages.count
      this.$emit('count', this.count)
    }
  }

}
</script>

<style lang="scss">
#push-list {
  thead>tr {
    background-color: #E8E8E8;
    th {
      color: #787878;
      &:last-child {
        padding-right: 32px;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.message {
  min-width: 650px;
  padding: 10px;
  border: 1px solid #B9B9B9;
  width: fit-content;
  border-radius: 10px;
  max-height: 200px;
  overflow-y: auto;
  box-sizing: border-box;
  img {
    box-sizing: border-box;
  }
}
.bubble {
  display: flex;
  gap: 23px;
  padding: 10px;
  border: 1px solid #B9B9B9;
  border-radius: 10px;
  max-height: 200px;
  font-size: 18px;
  &>div:nth-child(2) {
    overflow-y: auto;
    &>div:nth-child(1) {
      font-weight: bold;
    }
  }
}
.ff {
    margin: auto;
    width: 130px;
    height: 40px;
    background: #B9B9B9;
    font-weight: 400;
    font-size: 16px;
    line-height: 23px;
    letter-spacing: 0.1em;
    color: #FFFFFF;
    border-radius: 20px;
    display: flex;align-items: center;justify-content: center;
  }
.type {
    margin: auto;
    width: 100px;
    height: 40px;
    background: #B9B9B9;
    font-weight: 400;
    font-size: 14px;
    line-height: 23px;
    letter-spacing: 0.1em;
    color: #FFFFFF;
    border-radius: 20px;
    display: flex;align-items: center;justify-content: center;
}
.pop {
  display: none;
  position: absolute;
  width: 385px;
  height: fit-content;
  flex-direction: column;
  background: #ECF3FF;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  font-weight: 400;
  font-size: 18px;
  line-height: 26px;
  text-align: right;
  letter-spacing: 0.1em;
  color: var(--color-pri);
  padding: 25px 28px;
  z-index: 10;
  gap: 15px;
  top: 49px;
  left: 0;
  &>div{
    display: flex;
    gap: 27px;
    align-items: flex-start;
    &>div:nth-child(1) {
      width: 40px;
      flex-wrap: nowrap;
      white-space: nowrap;
    }
    &>div:nth-child(2) {
      text-align: start;
    }
  }
}
.ff {
  position: relative;
}
.ff:hover{
  .pop {
    display: flex;
  }
}
.record {
  border-bottom: 1px solid #B9B9B9;
  td {
    font-weight: 400;
    font-size: 20px;
    line-height: 29px;
    text-align: center;
    letter-spacing: 0.1em;
    color: #787878;
    &:last-child {
      padding-right: 32px;
      }
  }
}
#push-list {
  // padding: 18px 32px 20px 18px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
</style>
